export class Agent {
  id?: number;
  alternativeIdentifier?: number;
  name?: string;
  email?: string;
  active?: boolean;

  static orderAgentByName(agents: Agent[]) {
    return agents.sort((a, b) => (a.name > b.name) ? 1 : -1);
  }
}
